import React from "react";
import { UIMessage } from "ai";
import { Button } from "../../../components/ui/button";
import { Send } from "lucide-react";
import { markdownToHtmlForSlack, markdownToSlackMrkdwn } from "../../../lib/slack-utils";
import { useChatActions } from "./chat-subpage";
import { CopyButton } from "../../../components/shared/copy-button";

function extractTextFromMessage(message: UIMessage): string | null {
    const textParts = message.parts
        .filter((p): p is { type: "text"; text: string } => p.type === "text")
        .map((p) => p.text);
    return textParts.length > 0 ? textParts.join("\n\n") : null;
}

interface Props {
    message: UIMessage;
}

export function StatusUpdateMessageActions({ message }: Props) {
    const { onMarkAsSent } = useChatActions();
    const text = extractTextFromMessage(message);

    if (!text) return null;

    // Don't show actions for "no updates" messages
    if (text.toLowerCase().includes("no significant updates")) {
        return null;
    }

    return (
        <div className="mt-3 flex gap-2">
            <CopyButton
                text={text}
                label="Copy for Slack"
                transform={markdownToSlackMrkdwn}
                htmlTransform={markdownToHtmlForSlack}
            />
            {onMarkAsSent && (
                <Button size="sm" className="gap-2" onClick={() => onMarkAsSent(text)}>
                    <Send className="h-4 w-4" />
                    Mark as Sent
                </Button>
            )}
        </div>
    );
}
